import React from 'react';
import { useConfig } from './config';

const TermsOfService = () => {
  const config = useConfig();
  const lastUpdated = "November 14, 2024";

  return (
    <main>
      <div className="max-w-3xl mx-auto px-4 py-6 sm:px-6 lg:px-8 bg-white rounded-lg shadow-xl my-8 relative">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-40 h-40 bg-blue-500 rounded-full filter blur-3xl opacity-5 -translate-y-1/2 translate-x-1/2"></div>
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-red-500 rounded-full filter blur-3xl opacity-5 translate-y-1/2 -translate-x-1/2"></div>
        
        {/* Content */}
        <h1 className="text-3xl font-bold text-gray-900 mb-4 relative inline-block">
          Terms of Service
          <span className="absolute -bottom-1 left-0 right-0 h-1 bg-gradient-to-r from-red-500 to-blue-500 rounded-full"></span>
        </h1>
        
        <p className="text-sm text-gray-600 mb-6">
          <strong>Last updated:</strong> {lastUpdated}
        </p>

        <p className="mb-4 text-gray-700">
          Welcome to <strong>{config.siteName}</strong>. By accessing or using our website, you agree to these Terms of Service. Please read them carefully.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          1. Acceptance of Terms
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          By accessing or using our website, you agree to be bound by these Terms of Service and our Privacy Policy. If you do not agree to these terms, please do not use our website.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          2. User Eligibility
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          Our website and services are intended for users who are at least 18 years old. By using our website, you confirm that you are at least 18 years old. If you are under 18, you may not use our website.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          3. User Accounts and Security
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          If you create an account on our website, you are responsible for maintaining the security of your account and for all activities that occur under your account. You must notify us immediately of any unauthorized use of your account or any other breach of security.
        </p>
        <p className="mb-4 text-gray-700">
          We reserve the right to suspend or terminate your account if we suspect any violation of these Terms of Service or for any other reason at our discretion.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          4. Intellectual Property
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          All content on our website, including but not limited to text, graphics, logos, images, and software, is the property of {config.siteName} or its content suppliers and is protected by international copyright, trademark, and other intellectual property laws.
        </p>
        <p className="mb-4 text-gray-700">
          You may not reproduce, distribute, display, or transmit any of the content on our website without our prior written permission.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          5. User Conduct
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          When using our website, you agree not to:
        </p>
        <ul className="list-disc list-inside mb-4 text-gray-700">
          <li>Violate any applicable laws or regulations</li>
          <li>Infringe the rights of others</li>
          <li>Attempt to gain unauthorized access to our website or systems</li>
          <li>Engage in any activity that disrupts or interferes with our website</li>
          <li>Use our website for any fraudulent or unlawful purpose</li>
          <li>Transmit any viruses, malware, or other harmful code</li>
        </ul>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          6. Limitation of Liability
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          To the maximum extent permitted by law, {config.siteName} and its affiliates, officers, employees, agents, and partners shall not be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the website.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          7. Changes to Terms
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          We reserve the right to modify these Terms of Service at any time. We will notify users of any changes by updating the date at the top of these terms. Your continued use of our website after any changes indicates your acceptance of the modified terms.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          8. Governing Law
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          These Terms of Service shall be governed by and construed in accordance with the laws of Australia, without regard to its conflict of law provisions.
        </p>

        <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4 relative inline-block">
          9. Contact Us
          <span className="absolute -bottom-1 left-0 right-0 h-px bg-gradient-to-r from-red-400 to-blue-400 rounded-full"></span>
        </h2>
        <p className="mb-4 text-gray-700">
          If you have any questions about these Terms of Service, please contact us at <a href={`mailto:${config.contactEmail}`} className="text-blue-600 hover:text-blue-800 relative group">
            {config.contactEmail}
            <span className="absolute bottom-0 left-0 w-full h-0.5 bg-blue-400 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></span>
          </a>.
        </p>
      </div>
    </main>
  );
};

export default TermsOfService;